import { FemaleIconOnCard } from "icons/FemaleIconOnCard"
import { MaleIconOnCard } from "icons/MaleIconOnCard"


export const IconOnCard = ({ gender }: any) => (
    gender === "male" ? <MaleIconOnCard viewBox="0 0 74 74" style={{ height: "100px", width: "100px" }} /> : <FemaleIconOnCard viewBox="0 0 74 74" style={{ height: "100px", width: "100px" }} />
)


